import { NationalMenuTileData } from './types';

const IMG_DOMAIN = 'https://www.pizzahut.com';

const MEAT_LOVERS_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_MeatLoversMelt_Web_175x203.jpg`;
const CHICKEN_BACON_PARM_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_ChickenBaconParmMelt_Web_175x203.jpg`;
const BUFFALO_CHICKEN_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_Product_BuffaloChickenMelt_Web_175x203v2.jpg`;
const PEPPERONI_LOVER_MELT_IMG = `${IMG_DOMAIN}/assets/w/tile/thor/Melts_ProductTile_PepLoverMelt_Web_175x203.jpg`;

const DIPPING_SAUCE_DESCRIPTION = 'Comes with one dipping sauce; no substitutions.';

const NOOP = () => {};

// national melts
const meatLovers = {
  id: 'melt1',
  name: 'Meat Lover\'s® Melt',
  mobileImageUrl: MEAT_LOVERS_IMG,
  desktopImageUrl: MEAT_LOVERS_IMG,
  productDescription: `A Melt loaded with pepperoni, ham, Italian sausage, pork, beef, bacon and cheese. Served with marinara for dipping. ${DIPPING_SAUCE_DESCRIPTION}`,
  priority: 0,
  vegetarian: false,
  handleClick: NOOP
};

const chickenBaconParmesan = {
  id: 'melt2',
  name: 'Chicken Bacon Parmesan Melt',
  mobileImageUrl: CHICKEN_BACON_PARM_IMG,
  desktopImageUrl: CHICKEN_BACON_PARM_IMG,
  productDescription: `A Melt loaded with chicken, bacon, creamy Alfredo sauce and cheese. Served with ranch for dipping. ${DIPPING_SAUCE_DESCRIPTION}`,
  priority: 1,
  vegetarian: false,
  handleClick: NOOP
};

const buffaloChicken = {
  id: 'melt3',
  name: 'Buffalo Chicken Melt',
  mobileImageUrl: BUFFALO_CHICKEN_IMG,
  desktopImageUrl: BUFFALO_CHICKEN_IMG,
  productDescription: `A Melt loaded with chicken, onion, buffalo sauce and cheese. Served with ranch for dipping. ${DIPPING_SAUCE_DESCRIPTION}`,
  priority: 2,
  vegetarian: false,
  handleClick: NOOP
};

const pepperoniLovers = {
  id: 'melt4',
  name: 'Pepperoni Lover\'s® Melt',
  mobileImageUrl: PEPPERONI_LOVER_MELT_IMG,
  desktopImageUrl: PEPPERONI_LOVER_MELT_IMG,
  productDescription: `A Melt loaded with pepperoni and cheese. Served with marinara for dipping. ${DIPPING_SAUCE_DESCRIPTION}`,
  priority: 2,
  vegetarian: false,
  handleClick: NOOP
};

const melts: NationalMenuTileData[] = [meatLovers, chickenBaconParmesan, buffaloChicken, pepperoniLovers];

export default melts;
